export default {
    API_URL: 'https://astro-api-lovat.vercel.app'
}

// https://astro-api-lovat.vercel.app


